<div class="dialog -m-6 flex flex-col">
  <!-- Header -->
  <div class="flex h-16 flex-0 items-center justify-between px-4">
    <div class="text-lg font-medium">
      {{ data.item.association?.name }}
      <mat-icon class="text-secondary mx-1 icon-size-4">chevron_right</mat-icon>
      Unit {{ data.item.unit?.unit_number }}
    </div>
    <button mat-icon-button (click)="dialogRef.close()" [tabIndex]="-1">
      <mat-icon class="text-current" fontIcon="close"></mat-icon>
    </button>
  </div>
  <!-- Body -->
  <div class="overflow-y-auto px-0">
    <app-eservices-details [id]="data.item.id" [applicationType]="data.item.application_type" (onSave)="data.onSave.emit(); dialogRef.close()"></app-eservices-details>
  </div>
</div>
